import { Children, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { Tooltip } from 'react-tippy';
import cx from 'classnames';
import { connect } from 'react-redux';
import { result } from 'lodash';
import t from 'common/i18n';
import { asAbsolute } from 'root/routes/utils';
import { selectLocation } from 'root/selectors';
import MenuButton from 'root/components/MenuButton/MenuButton';
import UserBlock from 'root/components/UserBlock';
import SearchBox, { SEARCH_BOX_MODES } from 'root/components/SearchBox';
import Tabs from 'root/components/Tabs/Tabs';
import SVG_ICONS from '~/assets/icons/icons';

import './TabHeader.scss';

export const TabHeader = (props) => {
  const history = useHistory();

  const locPath = (props.location && props.location.pathname) || '';
  const inSearch = props.showSearch && (!!~locPath.indexOf('search') || props.expandSearch);
  const userName = props.userName || '';

  const onSearchClick = () => {
    if (inSearch) {
      props.searchClickHandler && props.searchClickHandler();
    } else {
      history.push({
        ...props.location,
        pathname: asAbsolute(props.source, 'search'),
      });
    }
  };

  const onBackClick = () => {
    history.goBack();
    props.onBackNavigation && props.onBackNavigation();
  };

  const renderTabs = () => (!inSearch && props.navItems ? <Tabs items={props.navItems} className="self-end" key="subhead-links" /> : null);

  const renderBackButton = () =>
    props.showBackButton || (inSearch && !props.hideBackButton) ? (
      <Fragment key="subhead-back">
        <MenuButton dataTest="back-button" className="pointer back-button pt-3 pr-3 pb-3 pl-3" iconSize={22} icon={SVG_ICONS.BACK} onClick={onBackClick} />
        <div className="divider bc-window-border mr-3" />
      </Fragment>
    ) : null;

  const renderSearchBox = () =>
    props.showSearch ? (
      <SearchBox
        key="tabheader_searchbox"
        mode={inSearch ? SEARCH_BOX_MODES.EXPANDED : SEARCH_BOX_MODES.BUTTON}
        inputPlaceholder={props.searchInputPlaceholder || t('search_placeholder')}
        searchHandler={onSearchClick}
        termChangeHandler={props.searchTermHandler}
        searchOptions={props.searchOptions}
        selectedSearchOption={props.selectedSearchOption}
        searchOptionHandler={props.searchOptionHandler}
        showClearButton={props.showClearButton}
        onClearClickHandler={props.onClearClickHandler}
        onEscClickHandler={props.onEscClickHandler}
        clearBtnTip={props.clearBtnTip}
        value={props.searchTerm}
      />
    ) : null;

  const renderTitle = () =>
    !inSearch &&
    !props.navItems &&
    props.title && (
      <span data-test="tab-header-title" className="tab-header-title pl6 pr6" key="th_title">
        {result(props, 'title', null)}
      </span>
    );

  const renderTitleCenter = () =>
    props.titleCenter ? (
      <Tooltip
        key={props.titleCenter}
        title={props.titleCenter}
        arrow
        animation="scale"
        delay={250}
        duration={200}
        hideDelay={0}
        size="small"
        className="tip title-center"
      >
        <span key="title-center">{props.titleCenter}</span>
      </Tooltip>
    ) : null;

  const getHeaderContent = () => [renderTitle(), renderTabs(), renderBackButton(), renderTitleCenter()];

  return (
    <div
      data-test="tab-header"
      className={cx('TabHeader', 'flex flex-none items-center bb bg-window bc-window-border ', {
        'search-mode': inSearch,
        'no-search': !inSearch,
      })}
    >
      {props.children && Children.count(props.children) ? props.children : getHeaderContent()}
      <div className="flex-grow-1 tr">{renderSearchBox()}</div>
      <UserBlock name={userName} onLogout={props.onLogout} key="tabheader_userblock" />
    </div>
  );
};

const mapState = (state) => ({ location: selectLocation(state) });

export default connect(mapState, null)(TabHeader);
